import { Component } from '@angular/core';

@Component({
  selector: 'app-export-bpf',
  templateUrl: './export-bpf.component.html',
  styleUrls: ['./export-bpf.component.scss']
})
export class ExportBpfComponent {

  public openCerfa(){
    window.open('https://www.formulaires.service-public.fr/gf/cerfa_10443.do');
  }

  public openNotice(){
    window.open('https://www.formulaires.service-public.fr/gf/getNotice.do?cerfaNotice=50199&cerfaFormulaire=10443');
  }

  public openGuid(){
    window.open('https://com.agate-erp.fr/docs/BPF/Mode%20d%27emploi%20-%20Remplir%20le%20BPF%202024.pdf');
  }
}
